import {
  getSwaggerJsonFile,
  getNoSqlSwaggerJsonFile,
} from "api/apiDocumentation";
import useRequest, { RequestStatus } from "hooks/useRequest";
import { SwaggerJsonFile } from "models/apiDocumentation/apiDocumentationModels";
import { useCallback } from "react";

const useApiData = (): {
  fetchData: () => void;
  data: SwaggerJsonFile | null;
  noSqlData: SwaggerJsonFile | null;
  status: RequestStatus;
  noSqlStatus: RequestStatus;
} => {
  const {
    data,
    status,
    request: fetchApiData,
  } = useRequest(getSwaggerJsonFile);
  const {
    data: noSqlData,
    status: noSqlStatus,
    request: fetchNoSqlApiData,
  } = useRequest(getNoSqlSwaggerJsonFile);

  const fetchData = useCallback(() => {
    fetchApiData();
    fetchNoSqlApiData();
  }, [fetchApiData, fetchNoSqlApiData]);

  return {
    data,
    noSqlData,
    status,
    noSqlStatus,
    fetchData,
  };
};

export default useApiData;
